import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  max-width: 1190px;
  padding: 32px 24px;
  background: ${theme.backgrounds.backgroundFour};
`

export const noInfluencersFound = (theme: Theme) => css`
  color: ${theme.colors.typographyThree};
  font-size: 16px;
`

export const header = (theme: Theme) => css`
  padding: ${theme.spacing(1, 0)};

  font-weight: 700;
`

export const content = css`
  margin: 0 auto;
  max-width: 754px;
  width: 100%;
`

export const influencerTypeContent = (theme: Theme) => css`
  margin-top: 10px;
  padding: 13px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: 14px;
`

export const influencerTypeWrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.spacing(3)};
`

export const influencersTable = (theme: Theme) => css`
  .table-row {
    gap: 8px;

    padding: 5px 5px 5px 12px;

    background-color: ${theme.colors.backgroundFive};
  }
`

export const indexCell = css`
  display: block;

  text-align: center;
`

export const coverImage = css`
  width: 32px;
  height: 32px;
`

export const iconButton = (theme: Theme) => css`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 8px;
  gap: 5px;
  border-radius: 10px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};

  svg {
    max-width: 100%;
  }
`

export const addInfluencerButton = css`
  margin-top: 10px;

  svg {
    width: 20px;
    height: 20px;
  }
`
